import moment from 'moment';

export default function generateTimestampedName(): string {
  return `clipboard_${moment().format('YYYY-MM-DD_HH:mm:ss')}`;
}
